import { render, staticRenderFns } from "./ImportSuccessAlerts.vue?vue&type=template&id=732a5545&scoped=true&"
import script from "./ImportSuccessAlerts.vue?vue&type=script&lang=ts&"
export * from "./ImportSuccessAlerts.vue?vue&type=script&lang=ts&"
import style0 from "./ImportSuccessAlerts.vue?vue&type=style&index=0&id=732a5545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a5545",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
